// extracted by mini-css-extract-plugin
export var checkbox = "_6i-0";
export var circle = "_6i-3";
export var horizontalContainer = "_6i-7";
export var sm = "_6i-5";
export var switch0 = "_6i-2";
export var switchDisabled = "_6i-8";
export var switchEnabled = "_6i-1";
export var textSwitchContainer = "_6i-9";
export var textSwitchOption = "_6i-a";
export var textSwitchOptionSelected = "_6i-b";
export var verticalContainer = "_6i-6";
export var xs = "_6i-4";